const TOKEN_PATTERN = /%%(.*?)%%/g;

export function getTokenValue(source, pathParts) {
    return pathParts.reduce((current, part, index) => {
        if (!current || typeof current !== "object") {
            return null;
        }

        const nextValue = current[part];

        if (index === pathParts.length - 1) {
            if (nextValue && typeof nextValue === "object" && "value" in nextValue) {
                return nextValue.value;
            }

            return nextValue ?? null;
        }

        return nextValue;
    }, source);
}

export function resolveTextTokens(content, resolveValue) {
    const template = String(content ?? "");

    return template.replace(TOKEN_PATTERN, (token, tokenPath) => {
        const [storageKey, ...pathParts] = tokenPath.split(".");
        const value = resolveValue({ storageKey, pathParts, tokenPath });

        return value === null || value === undefined || value === ""
            ? token
            : String(value);
    });
}
